import * as React from 'react';
import { Color } from 'modules/styles/colors';

const styles = {
  fill: 'none',
  stroke: Color.turquoiseDark,
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
} as const;

export default () => {
  return {
    svg: (
      <g id="prefix__Visit_Summary" data-name="Visit Summary">
        <g id="prefix__Visit_Summary-2" data-name="Visit Summary">
          <path
            className="prefix__cls-1"
            d="M36.5 24.2V7.8h-4.4M12.9 7.8H8.5v32.5h17.7M29.5 10.3V8.4a1.3 1.3 0 00-1.3-1.3V4.6H16.8v2.5a1.3 1.3 0 00-1.3 1.3v1.9zM12.3 15.4h20.4M12.3 19.3h20.4M12.3 23.5h15.9M12.3 27.6h11M12.3 31.7h10.8M12.3 35.8h3.2M39.8 32.1h-4.3v-4.3h-4v4.3h-4.3v4h4.3v4.3h4v-4.3h4.3v-4z"
            {...styles}
          />
        </g>
      </g>
    ),
    viewBox: '0 0 45 45'
  };
};
